import axios, { ENDPOINT } from '../../../utils/httpClient'

export const requeryTransaction = (reference) => {
    return axios(`${ENDPOINT}/payments/${reference}/status`)
}
